// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6d7569c5","858":"b2416e39"}[chunkId] + ".chunk.js";
};